import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Step, StepLabel, Stepper } from "@mui/material";
import { LicenseTypes, Operation } from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import { Label } from "../../../../../../stories/Label/Label";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";

import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { Form, Formik, FormikProps } from "formik";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetSupplierByNodeId, GetSuppliers } from "../queries/queries";
import {
  AtsAcLdgr,
  AtsAcLdgrOrderField,
  LdgrQueryType,
  UpdateSupplierResult,
  UpdateSupplierVar,
} from "../queries/types";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import { BrowserControlKeys, LabelProps } from "../../../../../../utils/types";
import InputNumber from "../../../../../common/Input/InputNumber";
import {
  PredefinedDataTypes,
  SupplierRequiredDetails,
} from "../../../../../../utils/formTypes";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import PredefinedAutocomplete from "../../../../../../customComponents/PredefinedAutocmplete";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  handleMUISelectEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import InputHoc from "../../../../../common/Input/Index";
import { UpdateSupplier } from "../queries/mutations";
import { supplierRequiredDetailsValidation } from "../../../../../../utils/validationSchema";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { AppContext } from "../../../../../../context/context";
import LoadingModal from "../../../../../pages/LoadingModal";
import Navbar from "../../../../../common/layout/Navbar";
import PredefinedSelect from "../../../../../../customComponents/PredefinedSelect";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
import { useBrowserControl } from "../../../../../../utils/browserControls";
export interface supplierProps {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  operation: Operation;
  step: number;
}

const RequiredDetails = ({ operation, step, setModalFlag }: supplierProps) => {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const { ledgerLabel } = useLabels();
  const { supplierRequiredDetails } = useFormJson();
  const SupplierStepHeader = (showMulLocation: boolean) => {
    if (showMulLocation)
      return [
        `${ledgerLabel} Basic Details`,
        `${ledgerLabel} Required Details`,
        "Multiple Location",
      ];
    else
      return [
        `${ledgerLabel} Basic Details`,
        `${ledgerLabel} Required Details`,
      ];
  };

  const initialValues: SupplierRequiredDetails = {
    gstNo: "",
    tanNo: "",
    panNo: "",
    vatNo: "",
    bankAcNo: "",
    bankName: "",
    bankBranch: "",
    bankIfsc: "",
    bankMicr: "",
    proficiency: "",
    alterContactPerson: "",
    alterContactPersonMobile: "",
    alterContactPersonEmail: "",
    alterContactPersonAadhar: "",
  };

  const [formData, setFormData] =
    useState<SupplierRequiredDetails>(initialValues);

  const { supplier_id, customer_id, company_id } = useUrlParams();
  const [message, setMessage] = useState(emptyMessage);



  const { user_details } = useLoggedInUserDetails();
  const { state } = useContext(AppContext);

  const [
    GetSupplier,
    { data: supplierData, loading: GetSupplierByNodeIdLoading },
  ] = useLazyQuery<{ node: AtsAcLdgr }, nodeVar>(GetSupplierByNodeId);

  const stepsHeader = SupplierStepHeader(
    supplierData ? supplierData.node.multiLocation : false
  );

  const [UpdateSupplierDetails, { loading: UpdateSupplierLoading }] =
    useMutation<UpdateSupplierResult, UpdateSupplierVar>(UpdateSupplier, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    });

  useEffect(() => {
    if (state.supplierId || supplier_id) {
      GetSupplier({
        variables: {
          id: supplier_id ? supplier_id : state.supplierId,
          
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            gstNo: data.node.supplier_details.gstNo,
            tanNo: data.node.supplier_details.tanNo,
            panNo: data.node.supplier_details.panNo,
            vatNo: data.node.supplier_details.vatNo,
            bankAcNo: data.node.supplier_details.bankAcNo,
            bankName: data.node.supplier_details.bankName,
            bankBranch: data.node.supplier_details.bankBranch,
            bankIfsc: data.node.supplier_details.bankIfsc,
            bankMicr: data.node.supplier_details.bankMicr,
            proficiency: data.node.supplier_details.proficiency,
            alterContactPerson:
              data.node.supplier_details.alterContactPerson,
            alterContactPersonMobile:
              data.node.supplier_details.alterContactPersonMobile,
            alterContactPersonEmail:
              data.node.supplier_details.alterContactPersonEmail,
            alterContactPersonAadhar:
              data.node.supplier_details.alterContactPersonAadhar,
          });
        }
      });
    }
  }, [GetSupplier, supplier_id]);

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<SupplierRequiredDetails>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleNumberChange = (name: string, value: string) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (
      (state.supplierId || supplier_id) &&
      supplierData &&
    
      customer_id
    ) {
      const customerUpdated = UpdateSupplierDetails({
        variables: {
          
          user_details,
          customer_id,
          supplier_id: supplier_id ? supplier_id : state.supplierId,
          input: {
            gstNo: formData.gstNo,
            tanNo: formData.tanNo,
            panNo: formData.panNo,
            vatNo: formData.vatNo,
            bankAcNo: formData.bankAcNo,
            bankName: removeMoreSpace(formData.bankName),
            bankBranch: formData.bankBranch,
            bankIfsc: formData.bankIfsc,
            bankMicr: formData.bankMicr,
            proficiency: formData.proficiency,
            alterContactPerson: removeMoreSpace(formData.alterContactPerson),
            alterContactPersonMobile: formData.alterContactPersonMobile,
            alterContactPersonEmail: formData.alterContactPersonEmail,
            alterContactPersonAadhar: formData.alterContactPersonAadhar,
          },
        },
        refetchQueries: [
          {
            query: GetSuppliers,
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsAcLdgrOrderField.CREATED_AT,
              },
              
              name: EMPTY_STRING,
              input: {
                query_type: LdgrQueryType.ALL,
                itemID: 0,
              },
            },
          },
        ],
      });
      const { data } = await customerUpdated;
      if (data && data.UpdateSupplier) {
        setMessage({
          flag: true,
          message: `${ledgerLabel} details updated successfully`,
          operation: Operation.UPDATE,
        });
        navigate(`/${customer_id}/company/masters/supplier`);
      }
    } else {
      if (customer_id) {
        setMessage({
          flag: true,
          message: "Customer details not found",
          operation: Operation.NONE,
        });
      } else
        setMessage({
          flag: true,
          message: `${ledgerLabel} details not found`,
          operation: Operation.NONE,
        });
    }
  };

  const handleClear = () => {
    const inputElement = document.getElementsByName(
      "gstNo"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(initialValues);
  };

  useBrowserControl({
    handleFunc: () => {
      navigate(
        `/${customer_id}/company/masters/supplier/${supplier_id}/basicdetails`
      );
    },
    browserControl: BrowserControlKeys.BACK,
  });

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      if (message.operation === Operation.CREATE) {
        if (supplierData && supplierData.node.multiLocation) {
          navigate(
            `/${customer_id}/company/masters/supplier/${supplier_id}/multipleLocation`
          );
        }
      }
    }
    setMessage(emptyMessage);
  };
  return (
    <>
      {operation === Operation.CREATE && (
        <>
          <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
          <Title>Add {ledgerLabel} Details</Title>
        </>
      )}
      <Formik
        initialValues={formData}
        validationSchema={supplierRequiredDetailsValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form
              className={`supplier__add${
                operation === Operation.CREATE ? "" : "--modal"
              }`}
            >
              {operation === Operation.UPDATE ? (
                <div className="supplier__add--title">
                  <Title>Edit Required Details</Title>

                  <img src={Close} alt="" onClick={() => setModalFlag(false)} />
                </div>
              ) : null}
              {operation === Operation.CREATE ? (
                <Stepper alternativeLabel activeStep={step - 1}>
                  {stepsHeader.map((step, index) => {
                    return (
                      <Step key={index}>
                        <StepLabel>{step}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              ) : null}

              <div
                className={`supplier__add--form${
                  operation === Operation.CREATE ? "" : "--edit"
                }`}
              >
                <div className="supplier__add--form-details">
                  <div className="supplier__add--form-details--left">
                    <div className="supplier__add--details">
                      <h4>Required Details</h4>
                    </div>
                    {supplierRequiredDetails.requiredDetails.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <React.Fragment>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => handleValueChange(e, meta)}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "textarea") {
                          return (
                            <React.Fragment>
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    city: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.city as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.country as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                inputProps={{
                                  required: true,
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                type={field.dataType}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="supplier__add--form-details--right">
                    <div className="supplier__add--details">
                      <h4>Alternate Contact Person Details</h4>
                    </div>
                    {supplierRequiredDetails.AltContactPerson.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <React.Fragment>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => handleValueChange(e, meta)}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                />
                              </div>

                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                />
                              </div>

                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    place: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.place as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.country as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                inputProps={{
                                  required: true,
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                type={field.dataType}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>

                <Button
                  mode={
                    supplierData && supplierData.node.multiLocation
                      ? "save-continue"
                      : "save"
                  }
                  type="submit"
                />
                <Button mode="clear" type="button" onClick={handleClear} />
                <Button
                  mode={operation === Operation.CREATE ? "back" : "cancel"}
                  type="button"
                  onClick={() => {
                    if (operation === Operation.CREATE) {
                      navigate(
                        `/${customer_id}/company/masters/supplier/${supplier_id}/basicdetails`
                      );
                    } else {
                      setModalFlag(false);
                    }
                  }}
                />
              </div>
            </Form>
          );
        }}
      </Formik>

      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        // handleDelete={HandleDelete}
      />
      {/* <Modal
        isOpen={addMultipleLocation}
        style={CustomModalStyles}
        ariaHideApp={false}
      >
        <MultiLocation
          setModalFlag={setAddMultipleLocation}
          operation={operation}
        />
      </Modal> */}
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={GetSupplierByNodeIdLoading || UpdateSupplierLoading}
      />
    </>
  );
};

export default RequiredDetails;
